(function ($, window, document) {
    'use strict';

    window.AdminKit = window.AdminKit || {};

    var activeRequests = 0;

    function setLoading(isLoading) {
        activeRequests += isLoading ? 1 : -1;
        activeRequests = Math.max(activeRequests, 0);
        $('body').toggleClass('ajax-loading', activeRequests > 0);
    }

    function clearValidation($scope) {
        $scope.find('.error-message').text('').hide();
        $scope.find('.form-control').removeClass('is-invalid');
    }

    function mapValidationErrors(errors, $scope) {
        $.each(errors, function (field, messages) {
            var message = Array.isArray(messages) ? messages[0] : messages;
            var fallbackField = field.indexOf('.') > -1 ? field.split('.')[0] : field;
            var $error = $scope.find('[data-error="' + field + '"]');
            var $input = $scope.find('[name="' + field + '"]');

            if (!$error.length) {
                $error = $scope.find('[data-error="' + fallbackField + '"]');
            }

            if (!$input.length) {
                $input = $scope.find('[name="' + fallbackField + '"], [name="' + fallbackField + '[]"]');
            }

            $error.text(message).show();
            $input.addClass('is-invalid');
        });
    }

    window.showToast = function (type, message) {
        if (!message || typeof toastr === 'undefined') {
            return;
        }

        toastr.options = {
            closeButton: true,
            progressBar: true,
            positionClass: 'toast-top-right',
            timeOut: 3200,
            extendedTimeOut: 1200
        };

        toastr[type || 'info'](message);
    };

    window.ajaxRequest = function (options) {
        var settings = $.extend({
            method: 'GET',
            data: {},
            dataType: 'json',
            processData: true,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            showLoader: true,
            form: null,
            success: function () {}
        }, options);

        if (settings.form) {
            clearValidation($(settings.form));
        }

        return $.ajax({
            url: settings.url,
            method: settings.method,
            data: settings.data,
            dataType: settings.dataType,
            processData: settings.processData,
            contentType: settings.contentType,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                'X-Requested-With': 'XMLHttpRequest'
            },
            beforeSend: function () {
                if (settings.showLoader) {
                    setLoading(true);
                }
            },
            success: function (response) {
                settings.success(response);
            },
            error: function (xhr) {
                var response = xhr.responseJSON || {};

                if (xhr.status === 422 && response.errors && settings.form) {
                    mapValidationErrors(response.errors, $(settings.form));
                    return;
                }

                window.showToast('error', response.message || 'Something went wrong. Please try again.');
            },
            complete: function () {
                if (settings.showLoader) {
                    setLoading(false);
                }
            }
        });
    };

    window.closeModal = function () {
        $('body').removeClass('modal-open');
        $('#adminModal').attr('aria-hidden', 'true');
        $('.admin-modal, .admin-modal-backdrop').removeClass('show');
    };

    window.openModal = function (options) {
        var settings = $.extend({
            title: '',
            url: '',
            size: 'md'
        }, options);

        var $modal = $('#adminModal');
        var $dialog = $modal.find('.admin-modal-dialog');
        var $body = $modal.find('.admin-modal-body');

        $dialog.removeClass('admin-modal-sm admin-modal-md admin-modal-lg admin-modal-xl')
            .addClass('admin-modal-' + settings.size);
        $('#adminModalTitle').text(settings.title);
        $body.html('<div class="modal-loader"><i class="fa-solid fa-spinner"></i><span>Loading</span></div>');

        $('body').addClass('modal-open');
        $modal.attr('aria-hidden', 'false');
        $('.admin-modal, .admin-modal-backdrop').addClass('show');

        window.ajaxRequest({
            url: settings.url,
            method: 'GET',
            dataType: 'html',
            success: function (html) {
                $body.html(html);
                window.initSelect2($body);
                $('[name="user_type"]').trigger('change');
            }
        });
    };

    window.confirmAction = function (options) {
        var settings = $.extend({
            title: 'Are you sure?',
            message: 'This action cannot be undone.',
            url: '',
            method: 'POST'
        }, options);

        Swal.fire({
            title: settings.title,
            text: settings.message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, continue',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                popup: 'swal-custom-popup',
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn'
            }
        }).then(function (result) {
            if (!result.isConfirmed) {
                return;
            }

            window.ajaxRequest({
                url: settings.url,
                method: settings.method,
                success: function (response) {
                    window.showToast('success', response.message);
                    window.reloadDataTables();
                }
            });
        });
    };

    $(document).on('click', '.js-open-modal', function () {
        window.openModal({
            title: $(this).data('title'),
            url: $(this).data('url'),
            size: $(this).data('size') || 'md'
        });
    });

    $(document).on('click', '[data-modal-close]', function () {
        window.closeModal();
    });

    $(document).on('submit', '.ajax-form', function (event) {
        event.preventDefault();

        var form = this;
        var $form = $(form);
        var $submit = $form.find('[type="submit"]');
        var formData = new FormData(form);
        var method = formData.get('_method') ? 'POST' : ($form.attr('method') || 'POST');

        $submit.prop('disabled', true).addClass('is-loading');

        window.ajaxRequest({
            url: $form.attr('action'),
            method: method,
            data: formData,
            processData: false,
            contentType: false,
            form: form,
            success: function (response) {
                window.closeModal();
                window.reloadDataTables();
                window.showToast('success', response.message);
            }
        }).always(function () {
            $submit.prop('disabled', false).removeClass('is-loading');
        });
    });

    $(document).on('click', '.js-confirm-action', function () {
        window.confirmAction({
            title: $(this).data('title'),
            message: $(this).data('message'),
            url: $(this).data('url'),
            method: $(this).data('method') || 'POST'
        });
    });

    $(document).on('change', '.js-change-status', function () {
        var $switch = $(this);
        var wasChecked = !$switch.prop('checked');

        window.ajaxRequest({
            url: $switch.data('url'),
            method: 'PATCH',
            success: function (response) {
                window.showToast('success', response.message);
                window.reloadDataTables();
            }
        }).fail(function () {
            $switch.prop('checked', wasChecked);
        });
    });
})(jQuery, window, document);
